type UseMarketingSeoOptions = {
  seoMeta?: SeoMetaInfoStoryblok;
  image?: string;
  pageName?: string;
  includeCanonical?: boolean;
  includeSchema?: boolean;
  includeOgTags?: boolean;
  ogLocale?: string;
};

export default function useMarketingSeo({
  seoMeta,
  image,
  pageName,
  includeCanonical,
  includeSchema,
  includeOgTags,
  ogLocale,
}: UseMarketingSeoOptions = {}) {
  const url = useRequestURL();
  const host = url.hostname;
  const domain = `https://${host}`;
  const siteName = 'Marketing Pages';
  const siteDescription = 'Marketing pages by DPG Media.';

  const normalizedSeo = seoMeta
    ? normalizeStoryblokSeo(seoMeta, { fallbackImage: image })
    : { title: '', description: '', image: '' };
  const title = normalizedSeo.title || pageName || siteName;
  const description = normalizedSeo.description || '';
  const finalPageName = pageName || normalizedSeo.title || siteName;

  if (import.meta.client && (!title || !description)) {
    useTelemetry({ message: 'Empty SEO data', metadata: { url: url.pathname } });
  }

  useStandardSeo({
    title,
    description,
    siteDescription,
    siteName,
    pageName: finalPageName,
    domain,
    image: normalizedSeo.image || image || undefined,
    path: url.pathname,
    includeCanonical,
    includeSchema,
    includeOgTags,
    ogLocale,
  });
}
